import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";

const SalaryModal = ({
  show,
  onHide,
  value = "",
  onSave,
  isApplyPage = false,
}) => {
  const dispatch = useDispatch();
  const [salary, setSalary] = useState("");
  const [error, setError] = useState("");
  const store = useSelector((state) => state.profile);
  //   console.log(store, "store");
  // useEffect(() => {
  //   if (store?.profileItem?.data?.preferred_salary) {
  //     setSalary(store.profileItem.data.preferred_salary);
  //   }
  // }, [store?.profileItem]);
  useEffect(() => {
  if (!show) return;

  if (isApplyPage) {
    setSalary(value || "");
  } else {
    const apiSalary = store?.profileItem?.data?.preferred_salary;
    if (apiSalary) setSalary(apiSalary);
  }

}, [show, value, isApplyPage]); // ✅ add value
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag, onHide]);

  // const onSubmit = () => {
  //   setError("");

  //   if (!salary) {
  //     setError("Salary is required");
  //     return;
  //   }

  //   if (Number(salary) <= 0) {
  //     setError("Salary must be greater than 0");
  //     return;
  //   }

  //   if (store?.profileItem?.data) {
  //     const payload = {
  //       name: store.profileItem.data.full_name,
  //       preferred_salary: salary,
  //     };

  //     dispatch(updateProfile(payload));
  //   }
  // };
  const onSubmit = () => {
    setError("");

    if (!salary) {
      setError("Salary is required");
      return;
    }

    if (Number(salary) <= 0) {
      setError("Salary must be greater than 0");
      return;
    }

    if (isApplyPage) {
      // ✅ LOCAL FLOW
      onSave(salary);
      onHide();
    } else {
      // ✅ API FLOW
      const payload = {
        name: store?.profileItem?.data?.full_name,
        preferred_salary: salary,
      };

      dispatch(updateProfile(payload));
    }
  };


  // useEffect(() => {
  //   if (!show) return;

  //   // ✅ Modal opened
  //   start();

  //   return () => {
  //     // ✅ Modal closed
  //     const result = stop();

  //     if (!result) return;

  //     dispatch(
  //       trackActivity({
  //         page_name: "CHANGE_ANNUAL_SALARY",
  //         duration: result.durationMinutes,
  //       }),
  //     );
  //   };
  // }, [show, dispatch, start, stop]);
  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "CHANGE_ANNUAL_SALARY", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_ANNUAL_SALARY" }));
    };
  }, [show, dispatch]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Update your salary</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="form-group">
            <Form.Label className="col-label">Annual Salary</Form.Label>
            <Form.Control
              type="number"
              value={salary}
              onChange={(e) => {
                setSalary(e.target.value);
                setError(""); // clear error while typing
              }}
              placeholder="e.g. 106230"
              className={`col-input ${error ? "is-invalid" : ""}`}
            />

            {error && <div className="error-message">{error}</div>}
          </Form.Group>
          <div className="buttons d-flex justify-content-center">
            <Button
              variant="primary"
              onClick={onSubmit}
              disabled={store?.isLoading || salary === "" || salary == null}
            >
              {store?.isLoading ? "Saving..." : "Save"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default SalaryModal;
